import { GoogleTagManager } from '@iwoca/frontend-tracking-library';

import { fetchQualifiedLeadType } from '../../api/lendingApi/apiQueries';
import logger from '../../utils/logger';

export const GET_QUALIFIED_LEAD_TYPE =
  '/api/paid_search/get_qualified_lead_type/';

export const trackLeadQuality = async () => {
  const qualifiedLeadTypeResponse = await fetchQualifiedLeadType();

  if (qualifiedLeadTypeResponse) {
    try {
      GoogleTagManager.trackEvent({
        category: 'Signup',
        event: 'Track Lead Value v2',
        label: qualifiedLeadTypeResponse.data?.qualified_lead_type,
      });

      qualifiedLeadTypeResponse.data?.qualified_lead_frameworks?.forEach(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (framework: any) => {
          GoogleTagManager.trackEvent({
            category: 'Signup',
            event: `Track QLF Value ${Object.keys(framework)[0]}`,
            label: framework[`${Object.keys(framework)[0]}`],
          });
        },
      );
    } catch (error) {
      logger.error('Failed to add Lead Value to data layer', {
        error: error,
      });
    }
  }
};
